import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import SectorBiddingsSectionContainer from '../containers/SectorBiddingsSection/SectorBiddingsSection.container'
import SectorBuyersSectionContainer from '../containers/SectorBuyersSection/SectorBuyersSection.container'
import SectorItemsAndProductsSectionContainer from '../containers/SectorItemsAndProductsSection/SectorItemsAndProductsSection.container'
import SectorProvidersSectionContainer from '../containers/SectorProvidersSection/SectorProvidersSection.container'
import SectorPurchasingMechanismsSectionContainer from '../containers/SectorPurchasingMechanismsSection/SectorPurchasingMechanismsSection.container'
import SectorSectionContainer from '../containers/SectorSection/SectorSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'

/**
 * The Sector's page.
 */
const Sector = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.sector} />
    <SearchBuyerPanelContainer />
    <SectorSectionContainer>
      <SectorProvidersSectionContainer />
      <SectorBuyersSectionContainer />
      <SectorPurchasingMechanismsSectionContainer />
      <SectorItemsAndProductsSectionContainer />
      <SectorBiddingsSectionContainer />
    </SectorSectionContainer>
  </BrandLayout>
)

export default Sector
